import { MenuItem } from '@material-ui/core';
import React from 'react';

import { SettingHeader, SettingsContainer, SettingsSelect } from '../components/BranchComponents';
import { getArrayDiferences } from '../../../helpers';

const NationalServiceSettings = ({ availableNationalMasterServices, pharmacyHasMasterServiceSetupByMasterId, pharmacyIncludedInMasterServiceByMasterId, error, onChange }) => {
  const selectedServices = availableNationalMasterServices?.filter(service => pharmacyIncludedInMasterServiceByMasterId[service._id]).map(service => service._id);

  const handleChange = (event) => {
    const addedServices = getArrayDiferences(event.target.value, selectedServices);
    
    if (addedServices.length === 1) {
      return onChange(addedServices[0], 'add');
    } 

    const removedServices = getArrayDiferences(selectedServices, event.target.value);

    if (removedServices.length === 1) {
      return onChange(removedServices[0], 'remove');
    }
  }

  return (
    <SettingsContainer>
      <SettingHeader>National Services</SettingHeader>
      {error && <div>{error}</div>}
      {availableNationalMasterServices && <SettingsSelect multiple onChange={handleChange} value={selectedServices}>
        {availableNationalMasterServices.map(service => {
          const isServiceDisabled =
            !pharmacyHasMasterServiceSetupByMasterId[service._id] && !pharmacyIncludedInMasterServiceByMasterId[service._id];

          return (
            <MenuItem
              disabled={isServiceDisabled}
              key={service._id}
              value={service._id}
            >
              {service.title}
            </MenuItem>
          );
        })}
      </SettingsSelect>}
    </SettingsContainer>
  );
};

export default NationalServiceSettings;
